import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'app/base-module/base-service/auth.service';
import { UtilitesService } from 'app/base-module/base-service/utilites.service';

@Component({
  selector: 'app-auth-handler',
  templateUrl: './auth-handler.component.html',
  styleUrls: ['./auth-handler.component.scss']
})
export class AuthHandlerComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private http: HttpClient,
    private utilitesService: UtilitesService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];

      if (token) {
        try {
            
            this.authService.setToken(token);

           
            const apiUrl = this.utilitesService.urlPrefix + 'auth/sso/me';

            this.http.get(apiUrl).subscribe({
                next: (userFull: any) => {
                    this.authService.setUser(userFull);
                   
                  window.location.href = '/home';
                },
                error: (err) => {
                    console.error('SSO Error:', err);
                    this.authService.logout(); 
                    this.router.navigate(['/auth/login']);
                }
            });

        } catch (e) {
            console.error('SSO Critical Error:', e);
            this.router.navigate(['/auth/login']);
        }
      } else {
        
        this.router.navigate(['/auth/login']);
      }
    });
  }
}